import { KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material';
import {
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { customPalette } from '../themes/customTheme';
const MemberCollapse = ({ member, metrics }) => {
  const [metricsUser, setMetricsUser] = useState();

  useEffect(() => {
    if (metrics?.length > 0) {
      metrics.forEach(metric => {
        if (metric.user_id === member.id) {
          setMetricsUser(metric);
        }
      });
    }
  }, [member]); //eslint-disable-line react-hooks/exhaustive-deps

  const formatMetric = (memberMetric, metricsUserMetric, metricsUser) => {
    const value = !metricsUser ? memberMetric : metricsUserMetric;
    const number = value ?? 0;

    return Intl.NumberFormat('es-AR', { maximumFractionDigits: 2 }).format(
      number
    );
  };

  return (
    <TableRow
      sx={{
        '&:last-child td, &:last-child th': { border: 0 },

        borderBottom: '1px solid' + customPalette.greyStoke,
        '&:hover': {
          background: customPalette.greyStoke,
        },
      }}
    >
      <TableCell sx={{ width: '3%', paddingTop: '10px !important' }} />
      <TableCell sx={{ width: '30%', paddingTop: '10px !important' }}>
        {member.username}
      </TableCell>
      <TableCell sx={{ width: '17%', paddingTop: '10px !important' }}>
        {formatMetric(
          member.total_visits,
          metricsUser?.total_visits,
          metricsUser
        )}
      </TableCell>
      <TableCell sx={{ width: '17%', paddingTop: '10px !important' }}>
        {formatMetric(
          member.total_notes,
          metricsUser?.total_notes,
          metricsUser
        )}
      </TableCell>
      <TableCell sx={{ width: '17%', paddingTop: '10px !important' }}>
        {formatMetric(member.total_rfv, metricsUser?.total_rfv, metricsUser)}
      </TableCell>
      <TableCell sx={{ width: '17%', paddingTop: '10px !important' }}>
        {formatMetric(
          member.total_subscribers,
          metricsUser?.total_subscribers,
          metricsUser
        )}
      </TableCell>
    </TableRow>
  );
};

export const RowMembersCollapse = ({
  item,
  openDefault = false,
  isSectionsPage = false,
}) => {
  const [open, setOpen] = useState(openDefault);
  const [metricsTeam, setMetricsTeam] = useState({
    visits: 0,
    notes: 0,
    rfv: 0,
    subscribers: 0,
  });

  useEffect(() => {
    setOpen(openDefault);
  }, [openDefault]);

  useEffect(() => {
    if (isSectionsPage) {
      setMetricsTeam({
        visits: item.total_visits,
        rfv: item.total_rfv,
        subscribers: item.total_subscribers,
        notes: item.total_notes,
      });
    } else {
      if (item.metrics.length > 0) {
        const newMetrics = {
          visits: 0,
          rfv: 0,
          subscribers: 0,
          notes: 0,
        };
        const uniqueUserIds = new Set(item.metrics.map(item => item.user_id));
        item.metrics.forEach(element => {
          newMetrics.visits += parseInt(element.total_visits, 10);
          newMetrics.rfv += element.total_rfv;
          newMetrics.subscribers += parseInt(element.total_subscribers, 10);
          newMetrics.notes += parseInt(element.total_notes, 10);
        });
        newMetrics.rfv =
          uniqueUserIds.size > 0 ? newMetrics.rfv / uniqueUserIds.size : 0;
        setMetricsTeam(newMetrics);
      }
    }
  }, [item]); //eslint-disable-line react-hooks/exhaustive-deps
  return (
    <React.Fragment key={item.id || item.section}>
      <TableRow
        sx={
          open
            ? {
                backgroundColor: customPalette.background.default,
              }
            : {}
        }
      >
        <TableCell sx={{ width: '3%' }}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
          </IconButton>
        </TableCell>
        <TableCell sx={{ width: '30%' }}>{item.name || item.section}</TableCell>
        <TableCell sx={{ width: '17%' }}>
          {Intl.NumberFormat('es-AR', { maximumFractionDigits: 2 }).format(
            metricsTeam.visits
          )}
        </TableCell>
        <TableCell sx={{ width: '17%' }}>
          {Intl.NumberFormat('es-AR', { maximumFractionDigits: 2 }).format(
            metricsTeam.notes
          )}
        </TableCell>
        <TableCell sx={{ width: '17%' }}>
          {metricsTeam.rfv
            ? Intl.NumberFormat('es-AR', {
                maximumFractionDigits: 2,
              }).format(metricsTeam.rfv)
            : '0.00'}
        </TableCell>
        <TableCell sx={{ width: '17%' }}>
          {Intl.NumberFormat('es-AR', { maximumFractionDigits: 2 }).format(
            metricsTeam.subscribers
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{
            paddingBottom: 0,
            paddingTop: 0,
            backgroundColor: customPalette.background.default,
          }}
          colSpan={6}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Table>
              <TableBody>
                {(isSectionsPage ? item?.redactors : item?.members)?.map(
                  member => (
                    <MemberCollapse
                      member={member}
                      metrics={!isSectionsPage && item.metrics}
                      key={member.id}
                    />
                  )
                )}
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
